<div class="container-fluid sm-pad-none">
    <data-list [dataset]="entities" [url]="url" show4Columns="true">
        <item [name]="'name'"></item>
    </data-list>
</div>
